import { render, staticRenderFns } from "./yc.vue?vue&type=template&id=b8b403de&scoped=true&"
import script from "./yc.vue?vue&type=script&lang=js&"
export * from "./yc.vue?vue&type=script&lang=js&"
import style0 from "./yc.vue?vue&type=style&index=0&id=b8b403de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b403de",
  null
  
)

export default component.exports